// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__l_IPH","container":"Footer_container__yt_R8","isDisabled":"Footer_isDisabled__67Twq","isAuthenticated":"Footer_isAuthenticated__znxnd"};